// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__oWGC-","wrapperFav":"styles_wrapperFav__Jm6OV","image":"styles_image__le891"};